import config from "../../../config";
import Button from "../../atoms/Button";
import Heading from "../../atoms/Heading";
import { SectionDetails } from "../../molecules/SectionDetails";

function Resume() {
  return (
    <SectionDetails
      column
      heading={<Heading>Resume</Heading>}
      details={
        <Button href={config.resumeLink} target="_blank" rel="noreferrer">
          View
        </Button>
      }
    />
  );
}

export default Resume;
